import { GridColDef } from '@mui/x-data-grid';
import React from 'react';

import { IconButton, Typography } from '@mui/material';
import Icons from '../../../components/icons';
import { OptionalConcessionMaster } from '../types';

export const getOptionalConcessionColumns = (
  onEdit: (row: OptionalConcessionMaster) => void,
  onDelete: (row: OptionalConcessionMaster) => void
): GridColDef[] => {
  return [
    {
      field: 'concessionName',
      headerName: 'Concession Name',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'type',
      headerName: 'Concession Type',
      flex: 1
    },
    {
      field: 'applicableOn',
      headerName: 'Applicable On',
      flex: 1,
      renderCell: (params) => (
        <Typography>{params.row.applicableOn?.[0]}</Typography>
      )
    },
    {
      field: 'amount',
      headerName: 'Concession Amount',
      flex: 1,
      renderCell: (params) => (
        <Typography>{params.row.concession.amount ?? '-'}</Typography>
      )
    },
    {
      field: 'percentage',
      headerName: 'Concession Percentage',
      flex: 1,
      renderCell: (params) => (
        <Typography>{params.row.concession.percentage ?? '-'}</Typography>
      )
    },
    {
      field: 'edit',
      headerName: 'Edit',
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      filterable: false,
      renderCell: (params) => (
        <IconButton onClick={() => onEdit(params.row)}>
          <Icons.EditBlackOutlined />
        </IconButton>
      )
    },
    {
      field: 'delete',
      headerName: 'delete',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton onClick={() => onDelete(params.row)}>
          <Icons.Delete />
        </IconButton>
      )
    }
  ];
};
